"use client";
import { cn } from "@/utils/common.utils";
import { Button, ButtonProps } from "@mui/material";
import { Ref, forwardRef } from "react";

const AppButton = forwardRef(
  (
    {
      children,
      size = "large",
      color = "normal",
      variant = "contained",
      disabled,
      ...prop
    }: AppButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    return (
      <Button
        {...prop}
        size={size}
        color={disabled ? "disabled" : color}
        variant={disabled ? "contained" : variant}
        ref={ref}
      >
        {children}
      </Button>
      // <button
      //   className={cn("btn", {
      //     "btn-darkgreen": color === "darkgreen",
      //   })}
      //   onClick={onclick}
      // >
      //   {children}
      // </button>
    );
  }
);
AppButton.displayName = "AppButton";
export type AppButtonProps = ButtonProps & {
  variant?: "contained" | "outlined" | "text";
  color?:
    | "primary"
    | "darkgreen"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | "dark"
    | "light"
    | "disabled"
    | "normal";
  size?: "small" | "medium" | "large" | "xlarge" | "xxlarge";
};
export default AppButton;
